// extracted by mini-css-extract-plugin
module.exports = {"loginBackground":"Login_loginBackground__1pwAB","card":"Login_card__2_O4L"};